"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Primitivo {
    constructor(valor, tipo) {
        this.valor = valor;
        this.tipo = tipo;
    }
    ejecutar() {
        return this;
    }
}
exports.Primitivo = Primitivo;
